export { PageVideosFormComponent as PageVideosDetail } from './component';


// WEBPACK FOOTER //
// ./src/pages/videos-form/index.tsx